import Network from '@/services/network'
import {ref} from 'vue'


export default function handleNGOPrograms(){
    const network = new Network;
    const loading = ref(false)

    const fetchProgramList = (query) => {
        return network.api('get', `/procurement/organization-setting/program` + query);
    }

    return {
        fetchProgramList,
        loading
    }
}